import { useMemo } from "react";

type NoneCase = {
	type: "none";
	applyPrice: undefined;
};

type CancelledPriceCase = {
	type: "cancelled-price";
	applyPrice: number;
};

type HostInsertedPriceCase = {
	type: "host-inserted-price";
	applyPrice: number;
};

type DiscountedPriceCase = {
	type: "discounted-price";
	applyPrice: number;
};

type Result = NoneCase | CancelledPriceCase | HostInsertedPriceCase | DiscountedPriceCase;

type Props = {
	// キャンセル料金
	cancelledPrice?: number;
	// 施設が上書きした金額
	hostInsertedPrice?: number;
	// ディスカウントされた金額
	discountedPrice?: number;
};

/**
 * 通常料金に対して割引をハンドリング
 */
export const useHandleApplyPrice = ({ cancelledPrice, hostInsertedPrice, discountedPrice }: Props): Result => {
	const isCancelledPrice = useMemo(() => cancelledPrice !== undefined, [cancelledPrice]);
	const isHostInsertedPrice = useMemo(() => hostInsertedPrice !== undefined, [hostInsertedPrice]);
	const isDiscountedPrice = useMemo(() => discountedPrice !== undefined, [discountedPrice]);

	// 順に優先度が高い
	/**
	 * キャンセル料金があれば
	 */
	if (isCancelledPrice) return { type: "cancelled-price", applyPrice: cancelledPrice ?? 0 };

	/**
	 * 施設が上書きした金額があれば
	 */
	if (isHostInsertedPrice) return { type: "host-inserted-price", applyPrice: hostInsertedPrice ?? 0 };

	/**
	 * ディスカウントされた金額があれば
	 */
	if (isDiscountedPrice) return { type: "discounted-price", applyPrice: discountedPrice ?? 0 };

	/**
	 * 割引がなければ
	 */
	return { type: "none", applyPrice: undefined };
};
